<template>
  <div class="mb-8">
    <div style="border-top: 2px solid var(--text-primary); width: 32px; margin-bottom: 12px;" aria-hidden="true" />
    <div v-if="$slots.actions" class="flex items-start justify-between gap-4 flex-wrap">
      <div>
        <h2 style="font-size: var(--text-3xl); color: var(--text-primary); letter-spacing: -0.02em; margin-bottom: 2px;">
          {{ title }}
        </h2>
        <p v-if="subtitle" class="label-caps page-header-subtitle m-0">{{ subtitle }}</p>
      </div>
      <div class="flex items-center gap-2 flex-wrap">
        <slot name="actions" />
      </div>
    </div>
    <template v-else>
      <h2 style="font-size: var(--text-3xl); color: var(--text-primary); letter-spacing: -0.02em; margin-bottom: 2px;">
        {{ title }}
      </h2>
      <p v-if="subtitle" class="label-caps page-header-subtitle m-0">{{ subtitle }}</p>
    </template>
    <slot />
  </div>
</template>

<script setup lang="ts">
/**
 * The editorial page header (accent rule + display title + caps subtitle)
 * that opens every tab view — extracted from the byte-identical copies the
 * views used to carry. Optional #actions slot renders a right-aligned,
 * wrap-friendly button row.
 */
defineProps<{
  title: string
  subtitle?: string
}>()
</script>
